export default __webpack_public_path__ + "static/media/person.e9e52072.png";